/** Created by azhou on 2019/3/29.*/
<template>
  <div class="border rounded p-3 pb-0 d-center-between flex-wrap bjys">
    <left-text-select class="w-45 mb-3" leftText="认证状态" :options="$GVAR.verifyType" v-model="storeVerify"/>                  
    <select-city class="mb-3 w-45"
                 leftText="省市区:"
                 mutiBlocks
                 @getCityInfo="info => this.cityInfo = info"
                 :provinceId="cityInfo.province"
                 :cityId="cityInfo.city"
                 :districtIds="cityInfo.district.map(v => v.id)"/>
    <div class="d-center-between mb-3 w-100">
      <div class="text-left ml-2 text-blue">用户总数：{{ total }}</div>
      <el-button type="primary" size="small" icon="el-icon-search" @click="$GFUN.pageChange(1);searchSubmit()">搜索</el-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'SearchCon',
    props: {
      total: {
        type: Number,
        default: 0
      }
    },
    computed: {
      ...mapGetters(['storeInfo']),
      storeType() { return Number(this.$route.query.storeType) },
      searchType() {
        switch (this.storeType) {
          case 3:return {cn:'酒店',starArr:this.$GVAR.HotelStar.slice(1,10),start:'入住日期',end:'离店日期'}
          case 5:return {cn:'民宿',left:'入住日期',start:'入住日期',end:'离店日期'}
          case 6:return {cn:'景区',starArr:this.$GVAR.scenicStarArr,start:'开始日期',end:'结束日期'}
          case 1:return {cn:'门店',left:'购买时间',start:'开始日期',end:'结束日期'}
          default:return {cn:'门店'}
        }
      }
    },
    data() {
      return {
        storeName: '',
        userName: '',
        storePhone:'',
        storeStar:'',
        storeVerify:'',
        storeContract:'',
        storeWechat:'',
        cityInfo:{
          district:[]
        }
      }
    },
    watch: {
      'storeType':'initSearchCon'
    },
    methods:{
      //清空搜索条件
      initSearchCon() {
        this.storeName = '';
        this.userName = '';
        this.storePhone = '';
        this.storeStar = '';
        this.storeVerify = '';
        this.storeContract = '';
        this.storeWechat = '';
        this.storeWechat = '';
        this.cityInfo = {
          province:'',
          city:'',
          district:[]
        };
      },
      //提交搜索条件
      searchSubmit() {
        let data = {
          title:this.storeName,
          userName: this.userName,
          phone:this.storePhone,
          star:this.storeStar,
          verify:this.storeVerify,
          sign:this.storeContract,
          wechat:this.storeWechat,
          pro:this.cityInfo.province,
          city:this.cityInfo.city,
          district:this.cityInfo.district.map(v => v.id).join(','),
        }
        this.$emit('getSearchCon',data);
      },
    }
  }
</script>

